var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgGraafschapCollege = function SvgGraafschapCollege(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 326.253,
    height: 450.975,
    viewBox: "0 0 244.69 338.231"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4e5ca6",
    d: "M0 0v260.82l118.269 77.41V207.274H90.29c-17.314 0-31.35-14.036-31.35-31.35V73.45c0-17.314 14.036-31.35 31.35-31.35h27.979V0zm104.622 84.02v80.08h13.647V84.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cad400",
    d: "M126.453 0v42.1h35.587a7.614 7.614 0 017.614 7.614v26.692a7.614 7.614 0 01-7.614 7.614h-35.587l.096 35.514h35.49a7.614 7.614 0 017.615 7.614c0 .014 0 .028-.002.041v72.441l.002.03a7.614 7.614 0 01-7.614 7.614h-35.56l.1 61.097 118.11-77.578V0z"
  })));
};

;
export default SvgGraafschapCollege;